module.exports = __webpack_public_path__ + "img/avatar-female.bb46e860.jpeg";